import React from 'react';
import {useTranslation} from 'react-i18next';

import styles from './modal-base.module.css';

const HomeModal = () => {
  const {t} = useTranslation();

  return (
    <>
      <h3 className={styles.modalTitle}>
        {t('fifa2022.useFullMaterialsWidget.home.modal.title')}
      </h3>
      <p className={styles.modalText}>
        {t('fifa2022.useFullMaterialsWidget.home.modal.text1')}
      </p>
      <p className={styles.modalText}>
        {t('fifa2022.useFullMaterialsWidget.home.modal.text2')}
      </p>
      <a
        className={styles.modalLink}
        href="https://www.qatar2022.qa/book"
        target="_blank"
        rel="noreferrer"
      >
        {t('fifa2022.useFullMaterialsWidget.home.modal.buttonText')}
      </a>
    </>
  );
};

export default HomeModal;

